import { Grid, Card, Icon } from "@scuf/common";

import TitlePage from "../../components/TitlePage/TitlePage";
import CalcinaDespacho from "../../components/Charts/Despacho/CalcinaDespacho";
import ArsenitoDespacho from "../../components/Charts/Despacho/ArsenitoDespacho";
import AcidoDespacho from "../../components/Charts/Despacho/AcidoDespacho";
import CobreDespacho from "../../components/Charts/Despacho/CobreDespacho";

import "./Despacho.css";

const Despacho = () => {
  const fChart = (titulo) => {
    return (
      <>
        {titulo ===
        "DESPACHO DE CALCINA, DIFERENCIADOS POR HÚMEDA Y SECA (tmh)" ? (
          <CalcinaDespacho
            body1={{
              opcion: 8,
              orden: 1,
              ultimo: 0,
              frecuencia: 1440,
              periodo: 7,
            }}
            body2={{
              opcion: 8,
              orden: 2,
              ultimo: 0,
              frecuencia: 1440,
              periodo: 7,
            }}
            height={220}
            showInLegend={true}
            name1="Calcina Húmeda"
            name2="Calcina Seca"
          />
        ) : titulo === "DESPACHO DE ARSENITO (tmh)" ? (
          <ArsenitoDespacho
            body={{
              opcion: 8,
              orden: 5,
              ultimo: 0,
              frecuencia: 1440,
              periodo: 7,
            }}
            height={220}
            name="Arsenito"
          />
        ) : titulo === "DESPACHO DE ÁCIDO (tmh)" ? (
          <AcidoDespacho
            body={{
              opcion: 8,
              orden: 4,
              ultimo: 0,
              frecuencia: 1440,
              periodo: 7,
            }}
            height={220}
            name="Ácido"
          />
        ) : (
          <CobreDespacho
            body={{
              opcion: 8,
              orden: 6,
              ultimo: 0,
              frecuencia: 1440,
              periodo: 7,
            }}
            height={220}
            name="Cobre"
          />
        )}
      </>
    );
  };

  const fGlobal = (titulo, kpi) => {
    return (
      <Card>
        <Card.Content
          className="text-center no-padding-left no-padding-right letter"
          style={{
            backgroundColor: "#404040",
            minHeight: "250px",
          }}
        >
          <div className="value-staticts-custom text-white letter mb-2 letter-origin mx-2">
            {titulo}
          </div>
          <Grid className="m-0 p-0">
            <Grid.Row xsWidth={12} sWidth={12} width={12} className="m-0 p-0">
              {/* {kpi !== '' && fDataPresent(kpi)} */}
            </Grid.Row>
            <Grid.Row>
              <Grid.Column xsWidth={12} sWidth={12} width={12}>
                {fChart(titulo)}
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Card.Content>
      </Card>
    );
  };

  return (
    <div className="minTopPage">
      <Grid className="mx-0 mb-0 p-0">
        <Grid.Row>
          <TitlePage title="Despacho" />
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={12} sWidth={12} xsWidth={12}>
            <div className="spaceAmongDiv1">
              <Card style={{ minHeight: "310px" }}>
                <Card.Header title="PROCESO">
                  <Icon name="increasing" root="common" />
                </Card.Header>
                <Card.Content>
                  <hr style={{ marginTop: "0px", marginBottom: "15px" }} />
                  <div className="spaceAmongDiv1">
                    <Grid.Row>
                      <Grid.Column xsWidth={12} sWidth={12} width={6}>
                        {fGlobal(
                          "DESPACHO DE CALCINA, DIFERENCIADOS POR HÚMEDA Y SECA (tmh)"
                        )}
                      </Grid.Column>
                      <Grid.Column xsWidth={12} sWidth={12} width={6}>
                        {fGlobal(
                          "DESPACHO DE ARSENITO (tmh)",
                          "DESPACHO DE ARSENITO (tmh)"
                        )}
                      </Grid.Column>
                    </Grid.Row>
                  </div>
                  <div className="spaceAmongDiv1">
                    <Grid.Row>
                      <Grid.Column xsWidth={12} sWidth={12} width={6}>
                        {fGlobal(
                          "DESPACHO DE ÁCIDO (tmh)",
                          "DESPACHO DE ÁCIDO (tmh)"
                        )}
                      </Grid.Column>
                      <Grid.Column xsWidth={12} sWidth={12} width={6}>
                        {fGlobal(
                          "CONCENTRADO DE COBRE (tmh)",
                          "CONCENTRADO DE COBRE (tmh)"
                        )}
                      </Grid.Column>
                    </Grid.Row>
                  </div>
                </Card.Content>
              </Card>
            </div>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </div>
  );
};
export default Despacho;
